module.exports = __webpack_public_path__ + "static/media/seeds-of-life-tablet.c16da9d3.jpg";